import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "./query-key";
import { fetchPropertiesUfCities } from "@/services/properties";

import type { Uf } from "@/types";

export function usePropertiesUfCities({ uf }: Uf) {
  return useQuery({
    queryKey: queryKeys.propertiesUfCities(uf),
    queryFn: () => fetchPropertiesUfCities({ uf }),
    enabled: Boolean(uf),
  });
}
